<template>
    <div class="loading-wrapper">
        <div class="cube-wrapper">
            <div class="cube-folding">
                <span class="leaf1"></span>
                <span class="leaf2"></span>
                <span class="leaf3"></span>
                <span class="leaf4"></span>
            </div>
        </div>
        <!-- <img :src="`${publicPath}/img/rcp/loader.gif`"> -->
        <!-- <div class="triangles">
            <div class="tri invert"></div>
            <div class="tri invert"></div>
            <div class="tri"></div>
            <div class="tri invert"></div>
            <div class="tri invert"></div>
            <div class="tri"></div>
            <div class="tri invert"></div>
            <div class="tri"></div>
            <div class="tri invert"></div>
        </div> -->
        <!-- <div id="floatBarsG">
            <div id="floatBarsG_1" class="floatBarsG"></div>
            <div id="floatBarsG_2" class="floatBarsG"></div>
            <div id="floatBarsG_3" class="floatBarsG"></div>
            <div id="floatBarsG_4" class="floatBarsG"></div>
            <div id="floatBarsG_5" class="floatBarsG"></div>
            <div id="floatBarsG_6" class="floatBarsG"></div>
            <div id="floatBarsG_7" class="floatBarsG"></div>
            <div id="floatBarsG_8" class="floatBarsG"></div>
        </div> -->
    </div>
    
</template>

<script>
    export default {
        name: "Loader",
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:''
            }
        }
    }
</script>